<form #form="ngForm" autocomplete="off">
    <h4 *ngIf="jobAttachments.length === 0">
        {{ 'applicant-tracker.applicants.create.noDocumentRequiredForUpload' | translate }}
    </h4>
    <div class="app-grid centered" *ngFor="let jobAttachment of jobAttachments; let i = index">
        <ng-container *ngIf="jobAttachment.jobAttachmentType === jobAttachmentTypes.File">
            <mat-form-field class="columns-3">
                <mat-label
                    >{{ 'applicant-tracker.applicants.create.upload' | translate }} {{ jobAttachment.name }}</mat-label
                >
                <ui-mat-file-upload
                    (fileSelected)="uploadFile($event, jobAttachment)"
                    placeholder="No file attached"
                    [allowedTypes]="['.pdf', '.csv', '.docx', '.xlsx']"
                ></ui-mat-file-upload>
                <ui-button type="outline">{{ 'applicant-tracker.applicants.create.browse' | translate }}</ui-button>
            </mat-form-field>
        </ng-container>
        <ng-container *ngIf="jobAttachment.jobAttachmentType === jobAttachmentTypes.Text">
            <ng-container *ngIf="!jobAttachment.linkAttached">
                <mat-form-field class="columns-3">
                    <mat-label>{{ jobAttachment.name }}</mat-label>
                    <input #link [name]="jobAttachment.name" matInput type="text" />
                </mat-form-field>
                <ui-button (click)="attachLink(jobAttachment, link)" class="columns-1" type="primary">{{
                    'applicant-tracker.applicants.create.attach' | translate
                }}</ui-button>
            </ng-container>
            <ng-container *ngIf="jobAttachment.linkAttached">
                <div class="app-grid centered margin-top-1">
                    <p class="columns-3 text-align-left">{{ jobAttachment.name }}</p>
                </div>
                <div class="app-grid centered margin-top-1 margin-bottom-2">
                    <a uiLink [href]="jobAttachment.link" target="_blank" class="link columns-1">{{
                        jobAttachment.link
                    }}</a>
                    <div class="columns-2 action-container">
                        <mat-icon (click)="removeLink(jobAttachment)" svgIcon="edit"></mat-icon>
                        <a (click)="removeLink(jobAttachment)" class="margin-left-1 remove-link">{{
                            'applicant-tracker.applicants.create.editLink' | translate
                        }}</a>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </div>
</form>
